export async function wait(timeMs: number) {
	return new Promise<void>((res) => setTimeout(res, timeMs))
}
